module.exports = __webpack_public_path__ + "img/drug-24.1db8ca7b.png";